export enum CheckboxSize {
  SM = 'sm',
  MD = 'md',
}

export interface CheckboxProps {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  size?: CheckboxSize;
  isDisabled?: boolean;
  ariaLabel?: string;
  className?: string;
  'data-testid'?: string;
}
